import React, { useState } from "react";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Button, TextField, CircularProgress, Grid } from "@mui/material";
import dayjs from "dayjs";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";

const UsageHistory = () => {
  const [msisdn, setmsisdn] = useState<any>("");
  const [action, setAction] = useState<Boolean>(false);
  const today = dayjs();
  const todayDate = today.format("YYYY-MM-DD");
  const oneMonthAgoDate = today.subtract(1, "month").format("YYYY-MM-DD");
  const [endDate, setEndDate] = useState<any>(todayDate);
  const [startDate, setStartDate] = useState<any>(oneMonthAgoDate);

  const handleGetUsageHistory = async () => {
    toast.dismiss();
    if (!msisdn.trim() || !startDate || !endDate || msisdn.trim().length <= 9) {
      toast.error("Please enter valid inputs.");
      return;
    }
    setAction(true);
    requestHistory();
  };

  const requestHistory = async () => {
    try {
      const res = await axiosInterceptorInstance.post(
        `/dashboard/UsageHistory`,
        {
          Msisdn: msisdn.trim(),
          StartDate: startDate,
          EndDate: endDate,
        },
      );

      const apiresponse = JSON.parse(res.data.body);
      toast.info(apiresponse.message);
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setAction(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Usage History</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField
                className="formControl"
                label="MSISDN"
                variant="outlined"
                value={msisdn}
                onChange={(e) => setmsisdn(e.target.value)}
                inputProps={{ maxLength: 20 }}
              />
            </Grid>
            <Grid item xs={4}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Start Date"
                  value={startDate ? dayjs(startDate) : null}
                  onChange={(newValue) => {
                    if (newValue) {
                      const formatted = newValue.format("YYYY-MM-DD");
                      setStartDate(formatted);
                      if (endDate && formatted > endDate) {
                        setEndDate(formatted);
                      }
                    } else {
                      setStartDate("");
                    }
                  }}
                  maxDate={endDate ? dayjs(endDate) : today}
                  disableFuture
                  slotProps={{
                    actionBar: {
                      actions: ["clear"],
                    },
                    textField: {
                      fullWidth: true,
                    },
                    field: {
                      readOnly: true,
                      onKeyDown: (e: React.KeyboardEvent) => e.preventDefault(),
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid item xs={4}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="End Date"
                  value={endDate ? dayjs(endDate) : null}
                  onChange={(newValue) => {
                    if (newValue) {
                      const formatted = newValue.format("YYYY-MM-DD");
                      setEndDate(formatted);
                    } else {
                      setEndDate("");
                    }
                  }}
                  minDate={startDate ? dayjs(startDate) : undefined}
                  maxDate={today}
                  disableFuture
                  slotProps={{
                    actionBar: {
                      actions: ["clear"],
                    },
                    textField: {
                      fullWidth: true,
                    },
                    field: {
                      readOnly: true,
                      onKeyDown: (e: React.KeyboardEvent) => e.preventDefault(),
                    },
                  }}
                />
              </LocalizationProvider>
            </Grid>

            <Grid
              item
              xs={4}
              style={{
                margin: "0 auto",
              }}
            >
              {!action && (
                <Button
                  onClick={handleGetUsageHistory}
                  className="dButton dButton2"
                  variant="contained"
                >
                  Request Report
                </Button>
              )}
              {action && (
                <Button className="dButton dButton2" variant="contained">
                  <CircularProgress color="inherit" size={30} />
                </Button>
              )}
            </Grid>
          </Grid>
        </div>
      </div>
    </motion.div>
  );
};

export default UsageHistory;
